import React, { useCallback, useEffect, useState } from "react"
import Group from "./Group"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material"
import CaptureVideoImage from "../hooks/Utils/CaptureVideoImage"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./Groups.module.css"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import BlockIcon from "@mui/icons-material/Block"
import LockOpenIcon from "@mui/icons-material/LockOpen"
import HighlightOffIcon from "@mui/icons-material/HighlightOff"
import Icn from "../UI/SharieIcn/SharieIcn"
import Spinner from "../UI/Spinner/Spinner"
import Feed from "../Feed/Feed"
import { throttle } from "lodash"
import { Edit as EditIcon } from "@mui/icons-material"
import { useLocation } from "react-router-dom"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import useError from "../hooks/Error/useError"
import TextField from "../UI/TextField"
import SkillLevelSelect from "../UI/SkillLevelSelect"

const Groups = () => {
  const [search_value, setSearchValue] = useState("")
  const [old_name, setOldName] = useState("")
  const [loading, setLoading] = useState(false)
  const [edited_group, setEditedGroup] = useState(null)
  const [waiting, setWaiting] = useState(true)
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const [myGroups, setMyGroups] = useState([])
  const [open, setOpen] = useState(false)
  const [image, setImage] = useState(null)
  const [is_compressing, setIsCompressing] = useState(false)
  const [filtered_groups, setFilteredGroups] = useState([])
  const [imin_groups, setImInGroups] = useState([])
  const [should_fetch, setShouldFetch] = useState(false)
  const [open_rus, setOpenRUS] = useState(false)
  const [group_to_delete, setGroupToDelete] = useState(null)
  const [editing, setEditing] = useState(false)
  const [newGroup, setNewGroup] = useState({
    name: "",
    cost: "",
    location: "",
    duration: "",
    description: "",
    maxParticipants: "",
    image: null,
    level: "beginner",
  })
  const { postData } = useApiService()
  const location = useLocation()
  const t = useTranslationSharie()
  const guest = localStorage.getItem("guest") === "true"
  const { Error: AlertError, error, success } = useError()

  useEffect(() => {
    if (location.state?.skill) setFilteredGroups([location.state?.skill])
    setTimeout(() => {
      setWaiting(false)
    }, 3000)
    postData("groups/getgroups", { user_name: localStorage.getItem("user") }).then((data) => {
      setMyGroups(data?.groups)
    })
    postData("groups/getgroupsimin", { user_name: localStorage.getItem("user") }).then((data) => {
      setImInGroups(data?.groups)
    })
  }, [should_fetch])
  const handleEdit = (group) => {
    setEditing(!editing)
    setOldName(group.name)
  }
  // Dialog handlers
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleScroll = useCallback(
    throttle(() => {
      const scrollTop = window.pageYOffset
      const windowHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight
      const totalScrollableHeight = docHeight - windowHeight
      const scrollPercent = (scrollTop || 0 / totalScrollableHeight) * 100
      setScrollPercentage(scrollPercent)
    }, 100),
    []
  )

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [handleScroll])
  const handleOpenRUS = (group) => {
    setOpenRUS(true)
    setGroupToDelete(group)
  }
  const handleCloseRUS = () => {
    setOpenRUS(false)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setNewGroup((prev) => ({ ...prev, [name]: value }))
  }

  const handleAddGroup = () => {
    if (
      newGroup.name &&
      newGroup.cost &&
      newGroup.location &&
      newGroup.duration &&
      newGroup.description &&
      newGroup.maxParticipants &&
      newGroup.level &&
      image
    ) {
      postData("groups/addgroup", {
        group: newGroup,
        image: image,
        user_name: localStorage.getItem("user"),
      }).then((data) => {})
      setNewGroup({
        name: "",
        cost: "",
        location: "",
        duration: "",
        description: "",
        maxParticipants: "",
      })
      handleClose()
      setShouldFetch(!should_fetch)
    } else {
      error("You Must Fill All Fields!")
    }
  }

  const handleSearchGroup = (value) => {
    setSearchValue(value)
    if (value) {
      setLoading(true)
      postData("groups/searchgroups", { group_name: value }).then((data) => {
        setFilteredGroups(data?.groups)
        setLoading(false)
      })
    } else {
      setFilteredGroups([])
    }
  }
  const handleJoinGroup = (group) => {
    postData("groups/joingroup", { group: group, user_name: localStorage.getItem("user") }).then(
      (data) => {
        if (data.message === "Successful") {
          setShouldFetch(!should_fetch)
          success("Joined Group!")
          try {
            postData("sharie/addnotification", {
              skill_name: group.name,
              from: localStorage.getItem("user"),
              type: "joined group",
              to: group.user_name,
            }).then((data) => {})
          } catch (error) {}
        } else {
          error(data.message)
        }
      }
    )
  }
  const handleCloseGroup = (group) => {
    postData("groups/closegroup", { group: group }).then((data) => {})
    setShouldFetch(!should_fetch)
  }
  const handleOpenGroup = (group) => {
    postData("groups/opengroup", { group: group }).then((data) => {})
    setShouldFetch(!should_fetch)
  }
  const handleDeleteGroup = () => {
    postData("groups/deletegroup", { group: group_to_delete }).then((data) => {})
    setShouldFetch(!should_fetch)
  }
  const handleExitGroup = (group) => {
    postData("groups/exitgroup", { group: group, user_name: localStorage.getItem("user") }).then(
      (data) => {
        if (data.message === "Failed") {
          error(data.error)
        }
      }
    )
    setShouldFetch(!should_fetch)
  }
  const handleSaveGroup = () => {
    setEditing(false)
    postData("groups/updategroup", { group: { ...edited_group, oldname: old_name } }).then(
      (data) => {
        setShouldFetch(!should_fetch)
        if (data.message === "Failed") {
          error("Couldn't Update Group!")
        } else {
          success("Group Updated!")
        }
      }
    )
  }

  return (
    <React.Suspense fallback={<Spinner />}>
      <T>
        <div style={{ padding: "1rem", backgroundColor: "#f5f7fa" }}>
          <AlertError />

          {/* Search and Create Section */}
          <div className={styles.search_container}>
            <TextField
              label={t("Search for groups")}
              variant='outlined'
              fullWidth
              onChange={(e) => handleSearchGroup(e.target.value)}
              style={{ margin: "1rem" }}
            />
            <Button
              variant='outlined'
              color='primary'
              onClick={() => handleSearchGroup(search_value)}
              sx={{ margin: "1rem" }}
            >
              Search
            </Button>
            <Button variant='contained' color='primary' onClick={handleOpen} disabled={guest}>
              Create New Group
            </Button>
          </div>

          {/* All Groups Section */}
          <div className={styles.groups_container}>
            {filtered_groups?.length > 0 ? (
              filtered_groups.map((group, index) => (
                <Group
                  {...group}
                  button={
                    <Button
                      sx={{ marginTop: "1rem" }}
                      variant='contained'
                      color='secondary'
                      onClick={() => handleJoinGroup(group)}
                      disabled={guest}
                    >
                      Join Group
                    </Button>
                  }
                />
              ))
            ) : waiting || loading ? (
              <Spinner />
            ) : (
              <p>No groups found</p>
            )}
          </div>
          <Divider className={styles.divider} />

          {/* My Groups Section */}
          <div>
            <h2>My Groups</h2>
            {myGroups?.length === 0 || !myGroups ? (
              waiting ? (
                <Spinner />
              ) : (
                <p>{t("You have no groups yet.")}</p>
              )
            ) : (
              <div className={styles.groups_container}>
                {myGroups?.map((group, index) => (
                  <div key={index}>
                    <Group
                      key={index}
                      {...group}
                      editing={editing}
                      setEditedGroup={setEditedGroup}
                    />
                    <div className={styles.group_button_box}>
                      {group.status === "open" ? (
                        <Icn
                          tooltip='Close Group'
                          color='primary'
                          onClick={() => handleCloseGroup(group)}
                          label='close'
                          icon={<BlockIcon />}
                        />
                      ) : (
                        <Icn
                          tooltip='Open Group'
                          color='primary'
                          onClick={() => handleOpenGroup(group)}
                          label='open'
                          icon={<LockOpenIcon />}
                        />
                      )}
                      <Icn
                        tooltip='Delete Group'
                        color='red'
                        onClick={() => handleOpenRUS(group)}
                        label='delete'
                        icon={<DeleteForeverIcon />}
                      />
                      <Icn
                        tooltip='Edit Group'
                        onClick={() => handleEdit(group)}
                        color='green'
                        label='edit'
                        icon={<EditIcon />}
                      />
                      {editing && (
                        <>
                          <Button onClick={handleSaveGroup}>Save</Button>
                          <Button color='secondary' onClick={() => setEditing(false)}>
                            Cancel
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <Divider className={styles.divider} />
          {/* Groups I'm in Section */}
          <div>
            <h2>Groups I'm in</h2>
            {imin_groups?.length === 0 || !imin_groups ? (
              waiting ? (
                <Spinner />
              ) : (
                <p>You haven't joined any groups yet</p>
              )
            ) : (
              <div className={styles.groups_container}>
                {imin_groups?.map((group, index) => (
                  <div key={index}>
                    <Group key={index} {...group} />
                    <Icn
                      tooltip='Exit Group'
                      color='error'
                      onClick={() => handleExitGroup(group)}
                      label='exit'
                      icon={<HighlightOffIcon />}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <AlertError />

          {/* Create New Group Dialog */}
          <Dialog
            open={open}
            onClose={handleClose}
            disableEnforceFocus
            disableRestoreFocus
            style={{ borderRadius: "0.8rem" }}
          >
            <DialogTitle>Create New Group</DialogTitle>
            <DialogContent>
              <TextField
                label={t("Name")}
                name='name'
                value={newGroup.name}
                onChange={handleChange}
                fullWidth
                margin='dense'
              />
              <TextField
                label={t("Cost Per User")}
                name='cost'
                value={newGroup.cost}
                onChange={handleChange}
                fullWidth
                margin='dense'
                type='number'
              />
              <SkillLevelSelect value={newGroup.level} onChange={handleChange} />
              <TextField
                label={t("Location")}
                name='location'
                value={newGroup.location}
                onChange={handleChange}
                fullWidth
                margin='dense'
              />
              <TextField
                label={t("Duration")}
                name='duration'
                value={newGroup.duration}
                onChange={handleChange}
                fullWidth
                margin='dense'
              />
              <TextField
                label={t("Description")}
                name='description'
                value={newGroup.description}
                onChange={handleChange}
                fullWidth
                margin='dense'
              />
              <TextField
                label={t("Max Participants")}
                name='maxParticipants'
                type='number'
                value={newGroup.maxParticipants}
                onChange={handleChange}
                fullWidth
                margin='dense'
              />
              <CaptureVideoImage
                setIsCompressing={setIsCompressing}
                image={image}
                setImage={setImage}
                open={open}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color='secondary'>
                Cancel
              </Button>
              <Button
                onClick={handleAddGroup}
                color='primary'
                variant='contained'
                disabled={is_compressing || guest}
              >
                Add Group
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={open_rus} onClose={handleCloseRUS}>
            <DialogTitle>Are You Sure?</DialogTitle>
            <DialogContent>
              Are you sure you want to delete this group? This action cannot be undone
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseRUS} color='secondary'>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleDeleteGroup()
                  handleCloseRUS()
                }}
                color='error'
                variant='contained'
                disabled={guest}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
          <Divider />
          <div>
            <div style={{ width: "95vw", textAlign: "center" }}>
              <h2>All Groups</h2>
            </div>
            <Feed scrollPercentage={scrollPercentage} groups={"true"} />
          </div>
        </div>
      </T>
    </React.Suspense>
  )
}

export default Groups
